/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { printStackSummary } from '../../../analytics';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  printStackSummary();
}), false, { type: 'TRACK_PRINT_STACK_SUMMARY_CLICK' });
